export default __webpack_public_path__ + "static/univers-cond-bbeb6be596422283b2343bb3a75f33d0.woff";